import { initGraphQLTada } from 'gql.tada';
import type { introspection } from './graphql-env.d.ts';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    ID: string;
    UUID: string;
    DateTime: string;
    Date: string;
    Long: number;
    URL: string;
    Position: Array<number>;
  }
}>();

export { readFragment } from 'gql.tada';
export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';

interface Edge<T> {
  node: T;
  cursor?: string;
}

interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

interface Connection<T> {
  edges: Edge<T>[] | null;
  pageInfo: PageInfo;
  totalCount: number;
}

interface List<T> {
  nodes: T[];
  pageInfo?: PageInfo;
  totalCount?: number;
}

interface GqlError {
  __typename: string;
  message: string;
}

interface PaginationQueryVariables {
  first?: number;
  last?: number;
  before?: string;
  after?: string;
}

export type { Connection, Edge, GqlError, List, PageInfo, PaginationQueryVariables };

